import {
  createBrowserRouter
} from "react-router-dom";
import Employer from "./components/Employer/Employer";
import EmployerIntro from "./components/Employer/EmployerIntro";
import EmployerProfile from "./components/Employer/EmployerProfile";
import Dashboard from "./components/User/Dashboard";
import Profile from "./components/User/Profile";
import UserIntro from "./components/User/UserIntro";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <UserIntro />,
  },
  {
    path: "/user",
    element: <Dashboard />,

  },
  {
    path: "/user/profile",
    element: <Profile />,

  },
  {
    path: "/employer",
    element: <EmployerIntro />,
  },
  {
    path: "/employer/find",
    element: <Employer />,
  },
  {
    path: "/employer/profile",
    element: <EmployerProfile />,
  },
]);